<template>
  <div class="class-wrapper">
    <apexchart ref="chart" :class="classList" type="bar" :options="chartOptions" :series="series"></apexchart>
  </div>
</template>

<script>
export default {
  name: "AverageBarChart",
  props: ["taskProgress", "groupLength"],
  data: function() {
    return {
      classList: 'hidden',
      series: [{
        data: [5.03, 25.00, 5.00]
      }],
    }
  },
  computed: {
    chartOptions() {
      return {
        chart: {
          type: 'bar',
          height: 150,
          fontFamily: 'Roboto, sans-serif',
          toolbar: {
            show: false
          },
        },
        plotOptions: {
          bar: {
            barHeight: '40%',
            distributed: true,
            horizontal: true,
            dataLabels: {
              position: 'bottom'
            },
            borderRadius: 10
          }
        },
        colors: ['#f2994a', '#56ccf2', '#9b51e0'],
        dataLabels: {
          enabled: true,
          textAnchor: 'start',
          style: {
            colors: ['#5F0100']
          },
          formatter: function (val, opt) {
            const mins = parseInt(
              val / 60,
              10
            );
            const secs = parseInt(
              val % 60,
              10
            );
            var newVal = mins + ":" + secs.toString().padStart(2, "0");
            return opt.w.globals.labels[opt.dataPointIndex] + " –  " + newVal + " mins " 
          },
          // offsetX: -12.5,
          offsetY: -25,
        },
        stroke: {
          width: 1,
          colors: ['#fff']
        },
        xaxis: {
          categories: ['MCQ', 'CFU', 'Bonus'],
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false
          },
          labels: {
            show: false
          },
        },
        yaxis: {
          labels: {
            show: false
          },
        },
        grid: {
          show: false,
          padding: {
            top: -10,
            left: -10
          },  
        },
        tooltip: {
          enabled: false
        },
        legend: {
          show: false
        }
      }
    },
    mcqAverage(){
      var arr = [];
      this.taskProgress.forEach((item) =>
        arr.push(item[0])
      );
      return this.getAverage(arr)
    },
    cfuAverage(){
      var arr = [];
      this.taskProgress.forEach((item) =>
        arr.push(item[1])
      );
      return this.getAverage(arr)
    },
    bonusAverage(){
      var arr = [];
      this.taskProgress.forEach((item) =>
        arr.push(item[2])
      );
      return this.getAverage(arr)
    },
    seriesData(){
      return [this.mcqAverage, this.cfuAverage, this.bonusAverage]
    },
    taskProgressObject(){
      this.updateChart();
      return this.taskProgress;
    }
  },
  watch: {
    taskProgress: function() {
      this.updateChart();
    },
    mcqAverage: function(val) {
      this.series = [{
        data: [val, this.seriesData[1], this.seriesData[2]]
      }];
    },
    cfuAverage: function(val) {
      this.series = [{
        data: [this.seriesData[0], val, this.seriesData[2]]
      }];
    },
    bonusAverage: function(val) {
      this.series = [{
        data: [this.seriesData[0], this.seriesData[1], val]
      }];
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.dispatchEvent(new Event('resize'));
      this.classList = 'revealed';
    });
  },
  methods: {
    updateChart() {
      this.chartOptions = {
       ...this.chartOptions
      }
      this.series = [{
        data: this.seriesData
      }]
    },
    getAverage: function(arr){
      var arrSum = arr.reduce(function(a,b){
        return a+b;
      }, 0);
      const average = arrSum / Number(this.groupLength)
      // console.log(average)
      return average;
    },
    timeParse: function(time) {
      return this.$filters.timeFormat(time);
    }
  }
}
</script>

<style>


</style>
